import {
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED,
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_PAGEABLE,
  REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED,
  CLEAR_ERROR_SUBMISSION_DATA_SIGNET_DESTROYED,
} from '../actions/types';

const initialState = {
  submissionDataSignetDestroyedAttachment: {},
  loading: false,
  error: undefined,
  attachmentContent: [],
  submissionDataSignetDestroyedAttachmentList: [],
  totalElements: '',
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
    attachmentContent: [],
  };
};

const addSubmissionDataSignetDestroyedStart = (state) => {
  return {
    ...state,
  };
};

const addSubmissionDataSignetDestroyed = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetDestroyedAttachment: action.payload,
  };
};

const addSubmissionDataSignetDestroyedError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findSubmissionDataSignetDestroyedByLatestVersioneStart = (state) => {
  return {
    ...state,
    //loading: true,
  };
};

const findSubmissionDataSignetDestroyedByLatestVersione = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetDestroyedAttachment: action.payload,
  };
};

const findSubmissionDataSignetDestroyedByLatestVersioneError = (
  state,
  action
) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findSubmissionDataSignetDestroyedByNameStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findSubmissionDataSignetDestroyedByName = (state, action) => {
  return {
    ...state,
    loading: false,
    attachmentContent: action.payload,
  };
};

const findSubmissionDataSignetDestroyedByNameError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const removeAttachment = (state) => {
  return {
    ...state,
    submissionDataSignetDestroyedAttachment: {},
  };
};

const findAllSubmissionDataSignetDestroyedStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllSubmissionDataSignetDestroyed = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetDestroyedAttachmentList: action.payload,
  };
};

const findAllSubmissionDataSignetDestroyedError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllSubmissionDataSignetDestroyedPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    submissionDataSignetDestroyedAttachmentList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_SUBMISSION_DATA_SIGNET_DESTROYED:
      return addSubmissionDataSignetDestroyed(state, action);
    case ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START:
      return addSubmissionDataSignetDestroyedStart(state);
    case ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR:
      return addSubmissionDataSignetDestroyedError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_DESTROYED:
      return findSubmissionDataSignetDestroyedByLatestVersione(state, action);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_START:
      return findSubmissionDataSignetDestroyedByLatestVersioneStart(state);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR:
      return findSubmissionDataSignetDestroyedByLatestVersioneError(
        state,
        action
      );

    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW:
      return findSubmissionDataSignetDestroyedByName(state, action);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START:
      return findSubmissionDataSignetDestroyedByNameStart(state);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR:
      return findSubmissionDataSignetDestroyedByNameError(state, action);

    case REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED:
      return removeAttachment(state);

    case CLEAR_ERROR_SUBMISSION_DATA_SIGNET_DESTROYED:
      return clearError(state);

    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST:
      return findAllSubmissionDataSignetDestroyed(state, action);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START:
      return findAllSubmissionDataSignetDestroyedStart(state);
    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR:
      return findAllSubmissionDataSignetDestroyedError(state, action);

    case GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_PAGEABLE:
      return findAllSubmissionDataSignetDestroyedPageable(state, action);

    default:
      return state;
  }
}
